var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 77,
    viewBox: "0 0 74 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.9996 59.8963L54.0087 43.2493V54.3324H20.2781V43.2493L33.7412 32.4692H20.2781L11.3262 40.3382V65.4155H54.0087V76.2652L73.9996 59.8963Z",
    fill: "#526830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M53.7223 21.9352V30.9627L38.4348 43.7959H53.7223L62.6735 35.931V10.8509H19.9944V0L0 16.3458L19.9944 33.0146V21.9352H53.7223Z",
    fill: "#526830"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/icon-logo.b4e0a2164dafca5936a7a47bcb5f6eb8.svg";
export { ForwardRef as ReactComponent };